import api from '../../lib/api'
import moment from 'moment'
import currencies from '../../data/currencies.json'

const STAT_URL =
  window.location.hostname === 'localhost'
    ? 'mintgamingapi.com'
    : `${window.location.host}`

function formCleanerAndArranger(form) {
  form.filter.startDate = moment(form.filter.startDate).unix()
  form.filter.endDate = moment(form.filter.endDate).unix()

  // if form.filter.providerid is an array that has one item, then convert it to integer
  // if (form.filter.providerid.length === 1)
  // 	form.filter.providerid = parseInt(form.filter.providerid[0])

  // if form.filter.gameid is an array that has one item, then convert it to integer
  if (form.filter.gameid.length === 1)
    form.filter.gameid = parseInt(form.filter.gameid[0])

  Object.keys(form.filter).forEach(key => {
    let isZeroOrNull = form.filter[key] === 0 || form.filter[key] === null
    let isEmptyArray =
      Array.isArray(form.filter[key]) && !form.filter[key].length
    if (isZeroOrNull || isEmptyArray) delete form.filter[key]
  })
  return form
}

export default {
  namespaced: true,
  state: {
    listData: [],
    player_list: [],
    loading: true,
    bigLoading: true,
    noData: false
  },
  mutations: {
    setLoading(state, data) {
      state.loading = data
    },
    setBigLoading(state, data) {
      state.bigLoading = data
    },
    setNoData(state, data) {
      state.noData = data
    }
  },
  actions: {
    setNoData({ commit }, data) {
      commit('setNoData', data)
    },
    setLoading({ commit }, data) {
      commit('setLoading', data)
    },
    setBigLoading({ commit }, data) {
      commit('setBigLoading', data)
    },
    convertData({ rootGetters, commit, state }, { data, refs }) {
      state.listData = []
      state.player_list = []
      if (refs.selected_game) {
        Object.keys(data).forEach(userId => {
          if (refs.currency) {
            state.player_list.push({
              id: userId,
              name: data[userId].name || '',
              in: data[userId].in,
              out: data[userId].out,
              profit: data[userId].in - data[userId].out
            })
          } else {
            let currs = data[userId]
            Object.keys(currs).forEach(curr => {
              state.player_list.push({
                id: userId,
                name: currs[curr].name || '',
                currency: currencies.find(c => c.id == curr).name,
                in: currs[curr].in,
                out: currs[curr].out,
                profit: currs[curr].in - currs[curr].out
              })
            })
          }
        })
      } else if (refs.selected_company) {
        if (refs.currency) {
          Object.keys(data).forEach(gameId => {
            state.listData.push({
              id: gameId,
              name: rootGetters['game/games'].find(cmp => cmp.id == gameId)
                ? rootGetters['game/games'].find(cmp => cmp.id == gameId).name
                : gameId,
              in: data[gameId].in,
              out: data[gameId].out,
              profit: data[gameId].in - data[gameId].out
            })
          })
        } else {
          Object.keys(data).forEach(gameId => {
            let currs = data[gameId]
            Object.keys(currs).forEach(curr => {
              state.listData.push({
                id: `${gameId}_${curr}`,
                name: rootGetters['game/games'].find(cmp => cmp.id == gameId)
                  ? rootGetters['game/games'].find(cmp => cmp.id == gameId).name
                  : gameId,
                currency: currencies.find(c => c.id == curr).name,
                in: currs[curr].in,
                out: currs[curr].out,
                profit: currs[curr].in - currs[curr].out
              })
            })
          })
        }
      } else if (refs.selected_category) {
        if (refs.currency) {
          let comp_data = []
          Object.keys(data).forEach(gameId => {
            let companyId = rootGetters['game/games'].find(
              cmp => cmp.id == gameId
            ).company_id
            let companyName = rootGetters['company/companies'].find(
              cmp => cmp.id == companyId
            ).name
            let foundCompany = comp_data.find(comp => comp.id == companyId)

            if (foundCompany) {
              foundCompany.in += data[gameId].in
              foundCompany.out += data[gameId].out
              foundCompany.profit += data[gameId].in - data[gameId].out
            } else {
              comp_data.push({
                id: companyId,
                name: companyName,
                in: data[gameId].in,
                out: data[gameId].out,
                profit: data[gameId].in - data[gameId].out
              })
            }
          })

          state.listData = comp_data
        } else {
          let comp_data = []
          Object.keys(data).forEach(gameId => {
            let currs = data[gameId]
            Object.keys(currs).forEach(curr => {
              let companyId = rootGetters['game/games'].find(
                cmp => cmp.id == gameId
              ).company_id
              let companyName = rootGetters['company/companies'].find(
                cmp => cmp.id == companyId
              ).name
              let companyCurrency = currencies.find(c => c.id == curr).name

              let foundCompany = comp_data.find(
                comp =>
                  comp.name == companyName && comp.currency == companyCurrency
              )

              if (foundCompany) {
                foundCompany.in += currs[curr].in
                foundCompany.out += currs[curr].out
                foundCompany.profit += currs[curr].in - currs[curr].out
              } else {
                comp_data.push({
                  id: companyId + '_' + curr,
                  name: companyName,
                  currency: companyCurrency,
                  in: currs[curr].in,
                  out: currs[curr].out,
                  profit: currs[curr].in - currs[curr].out
                })
              }
            })
          })

          state.listData = comp_data
        }
      } else {
        if (refs.currency) {
          let cat_data = []
          Object.keys(data).forEach(compId => {
            let catId = rootGetters['category/categories'].find(
              cat =>
                cat.id ==
                rootGetters['company/companies'].find(cmp => cmp.id == compId)
                  .category_id
            ).id
            let catName = rootGetters['category/categories'].find(
              cat =>
                cat.id ==
                rootGetters['company/companies'].find(cmp => cmp.id == compId)
                  .category_id
            ).name

            let fCat = cat_data.find(cat => cat.id == catId)
            if (fCat) {
              fCat.in += data[compId].in
              fCat.out += data[compId].out
              fCat.profit += data[compId].in - data[compId].out
            } else
              cat_data.push({
                id: catId,
                name: catName,
                in: data[compId].in,
                out: data[compId].out,
                profit: data[compId].in - data[compId].out
              })
          })
          state.listData = cat_data
        } else {
          let cat_data = []
          Object.keys(data).forEach(compId => {
            let currs = data[compId]
            Object.keys(currs).forEach(curr => {
              let catId = rootGetters['category/categories'].find(
                cat =>
                  cat.id ==
                  rootGetters['company/companies'].find(cmp => cmp.id == compId)
                    .category_id
              ).id
              let catName = rootGetters['category/categories'].find(
                cat =>
                  cat.id ==
                  rootGetters['company/companies'].find(cmp => cmp.id == compId)
                    .category_id
              ).name
              let catCurrency = currencies.find(c => c.id == curr).name

              let fCat = cat_data.find(
                cat => cat.name == catName && cat.currency == catCurrency
              )
              if (fCat) {
                fCat.in += currs[curr].in
                fCat.out += currs[curr].out
                fCat.profit += currs[curr].in - currs[curr].out
              } else
                cat_data.push({
                  id: catId + '_' + curr,
                  name: catName,
                  currency: catCurrency,
                  in: currs[curr].in,
                  out: currs[curr].out,
                  profit: currs[curr].in - currs[curr].out
                })
            })
          })

          state.listData = cat_data
        }
      }
      commit('setLoading', false)
    },
    async getStatSum({ commit, dispatch }, form) {
      commit('setNoData', false)
      let refs = form.refs
      delete form.refs
      const formData = await formCleanerAndArranger(form)
      let checkType = 'all'
      if (refs.selected_category) checkType = 'category'
      if (refs.selected_company) checkType = 'company'
      if (refs.selected_game) checkType = 'game'

      let { data } = await api.post(
        `https://stats.${STAT_URL}/game/stats/sum`,
        formData
      )

      if (Object.keys(data.data).length === 0) {
        commit('setNoData', true)
        dispatch('setLoading', false)
      } else dispatch('convertData', { data: data.data, checkType, refs })
    }
  },
  getters: {
    loading: state => state.loading,
    bigLoading: state => state.bigLoading,
    noData: state => state.noData,
    listData: state => state.listData,
    player_list: state => state.player_list
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/total.js